import { render, staticRenderFns } from "./my-upload.vue?vue&type=template&id=4cd25146&scoped=true"
import script from "./my-upload.vue?vue&type=script&lang=js"
export * from "./my-upload.vue?vue&type=script&lang=js"
import style0 from "./my-upload.vue?vue&type=style&index=0&id=4cd25146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd25146",
  null
  
)

export default component.exports